// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.schema-engine-status-list .list-group-item{
  background-color: transparent !important;
  border: none !important; 
  padding: 0.25rem 0; 
}

.ag-header {
  background-color: #f4f4f4; 
  font-family: "MarkBook", sans-serif;
  font-weight: 500; 
  letter-spacing: 0.5px; 
  font-size: 12px;
}

.ag-header-cell, .ag-header {
  overflow: visible !important;
}

.ag-header-cell[aria-sort="none"] .ag-header-cell-text::after {
  font-family: "Font Awesome 7 Pro", "Font Awesome 5 Free", sans-serif; 
  content: '\\f0dc'; 
  font-size: 12px;
  color: #000000d8;
  margin-left: 10px;
  margin-top: 0px; 
}
 
.ag-cell {
  font-family: "MarkBook", sans-serif;
  font-weight: 400 !important;
  font-size: 12px !important; 
  color: #212121 !important; 
  border: none !important;
  text-overflow: ellipsis ;
}

.ag-cell.ag-cell-actions-dropdown {
  overflow: visible;
}

.ag-column-last{
  border-right: 0px  !important;
}
.ag-floating-filter {  
  text-overflow: ellipsis;  
  width: 100%;  
  border: none !important;
} 
 
.ag-input-field-input.ag-text-field-input::placeholder {
  color: #00000080 !important;
}

.ag-input-field-input::placeholder {
  color: #00000080 !important;
}

.ag-input-field-input{
  padding-inline: 6%;
  border: 1px solid #0000006c;
  border-radius: 4px; 
  text-overflow: ellipsis;
}

.ag-input-field-input:focus {
  border: 1px solid #60a5fa !important;  
}

.ag-floating-filter select{
  padding-inline: 6%;
  width: 100%;
  margin-top: 0px;
  border: 1px solid #0000006c;
  border-radius: 4px; 
}

.ag-floating-filter-body  {
    margin-top: 0px;
    width: 100%;
} 
  
.boolean-toggle-floating-filter {
  padding: 0 10px;
  height: 24px;
  border: 1px solid #0000006c;
  border-radius: 0;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 14px;
  background-color: #fff;
  color: #000;
  user-select: none;
  transition: background-color 0.2s ease, color 0.2s ease;
}

.boolean-toggle-floating-filter.up {
  border-radius: 4px 0 0 4px;
}

.boolean-toggle-floating-filter.down {
  border-radius: 0 4px 4px 0;
}

.boolean-toggle-floating-filter.selected {
  background-color: #000;
  color: #fff;
}

 
.select-empty {
  color: #00000080;
  width: 100%;
  padding-inline: 6%; 
  border-radius: 4px;
  background-color: #ffffff ;
  text-overflow: ellipsis;
}

.select-normal { 
  font-style: normal;
  color: #000;
  width: 100%;
  padding-inline: 6%; 
  border-radius: 4px;
  background-color: #ffffff ;
}

.option-empty {
  color: #00000080;
  font-style: italic;
}

.option-normal {
  color: #000;
  font-style: normal;
}

.ag-floating-filter-input {
  font-weight: normal;
}

.ag-floating-filter-button-button{
    display: none;
}
 
 input.grey-checkbox[type="checkbox"] {
  appearance: none;
  -webkit-appearance: none;
  -moz-appearance: none;
  border: 2px solid #aaa;
  border-radius: 4px;
  background-color: white;
  cursor: pointer;
  position: relative;
}

input.grey-checkbox[type="checkbox"]:checked {
  background-color: #8e8b8b; 
  border-color: #000000;
}
input.grey-checkbox[type="checkbox"]::after {
  content: '';
  position: absolute;
  top: 1px;
  left: 4px;
  width: 4px;
  height: 9px;
  border: solid white;
  border-width: 0 2px 2px 0;
  transform: rotate(45deg);
  display: none;
}

input.grey-checkbox[type="checkbox"]:checked::after {
  display: block;
}

.ag-paging-panel {
  align-items: center;
  padding: 0 12px;
  font-size: 13px;
  height: 35px;
 }

.ag-paging-button:first-child {
  display: flex;
  justify-content: flex-start;
  width: 50px;
 }

.ag-paging-button:last-child {
  display: flex;
  justify-content: flex-end;
  width: 50px;
}

.ag-paging-page-summary-panel {
  width: 200px;
  text-align: center;
  white-space: nowrap;      
  overflow: hidden;         
  text-overflow: ellipsis;  
}

.ag-paging-row-summary-panel {
  width: 160px;
  text-align: center;
}

.skeleton-wrapper {
  width: 100%;
  height: 100%;
  box-sizing: border-box;
  display: flex;
  align-items: center;
}

.skeleton-box {
  width: 85%;
  height: 20px;
  border-radius: 6px;
  background-color: #e0e0e0;
  animation: skeleton-pulse 1.2s ease-in-out infinite;
  box-shadow: inset 0 0 4px rgba(0, 0, 0, 0.05);
}
.skeleton-box-short {
  width: 65%;
  height: 20px;
  border-radius: 6px;
  background-color: #e0e0e0;
  animation: skeleton-pulse 1.2s ease-in-out infinite;
  box-shadow: inset 0 0 4px rgba(0, 0, 0, 0.05);
}


@keyframes skeleton-pulse {
  0% {
    background-color: #e0e0e0;
  }
  50% {
    background-color: #f0f0f0;
  }
  100% {
    background-color: #e0e0e0;
  }
}

.skeleton-icon {
  width: 24px;
  height: 24px;
  border-radius: 50%;
  margin-left: 40%;
  background-color: #e0e0e0;
  animation: skeleton-icon-pulse 1.2s ease-in-out infinite;
}

@keyframes skeleton-icon-pulse {
  0% {
    background-color: #e0e0e0;
  }
  50% {
    background-color: #f0f0f0;
  }
  100% {
    background-color: #e0e0e0;
  }
}


.skeleton-button-row {
  display: flex;
  gap: 8px;
  justify-content: center;
  align-items: center;
  height: 100%;
  padding: 8px;
}

.skeleton-button {
  width: 25px;
  height: 25px;
  border-radius: 6px;
  background-color: #e0e0e0;
  animation: skeleton-button-pulse 1.4s ease-in-out infinite;
  box-shadow: inset 0 0 2px rgba(0, 0, 0, 0.05);
}

@keyframes skeleton-button-pulse {
  0% {
    background-color: #e0e0e0;
  }
  50% {
    background-color: #f0f0f0;
  }
  100% {
    background-color: #e0e0e0;
  }
}

.skeleton-date {
  width: 70%;
  height: 16px;
  border-radius: 4px;
  background: linear-gradient(
    90deg,
    #e0e0e0 0%,
    #f0f0f0 50%,
    #e0e0e0 100%
  );
  background-size: 200% 100%;
  animation: skeleton-loading 1.5s ease-in-out infinite;
  box-shadow: inset 0 0 4px rgba(0, 0, 0, 0.05);
}

@keyframes skeleton-loading {
  0% {
    background-position: 200% 0;
  }
  100% {
    background-position: -200% 0;
  }
}

.skeleton-state {
  display: flex;
  flex-direction: column;
  gap: 4px;
  width: 100%;
}

.skeleton-line {
  height: 10px;
  border-radius: 4px;
  background: linear-gradient(
    90deg,
    #d3d3d3 0%,
    #eaeaea 50%,
    #d3d3d3 100%
  );
  background-size: 200% 100%;
  animation: skeleton-state-loading 1.4s ease-in-out infinite;
  box-shadow: inset 0 0 4px rgba(0, 0, 0, 0.05);
}

.skeleton-line.short {
  width: 20%;
}

.skeleton-line.long {
  width: 60%;
}

@keyframes skeleton-state-loading {
  0% {
    background-position: 200% 0;
  }
  100% {
    background-position: -200% 0;
  }
}

.skeleton-image {
  width: 28px;
  height: 28px;
  border-radius: 6px;
  margin-left: 25%;
  background-color: #e0e0e0;
  animation: skeleton-button-pulse 1.4s ease-in-out infinite;
  box-shadow: inset 0 0 2px rgba(0, 0, 0, 0.05);
}

.operationalStatus-tooltip-body > * + * {
  margin-top: 5px; 
}
.operationalStatus-tooltip-body{
  background-color: white;
  border-radius: 5px;
  margin-bottom: 0px;
  box-shadow: 0 .2rem 0.3rem rgba(0, 0, 0, 0.38) !important;
} 
.operationalStatus-tooltip-status{
    font-size: small;
    font-style: italic;
}

.custom-tooltip {
  font-family: "MarkBook", sans-serif;
  position: relative;
  background-color: #ffffff;
  box-shadow: 0 .2rem 0.3rem rgba(0, 0, 0, 0.38) !important;
  display: inline-block;           /* allows width to auto-fit */
  padding: 8px 12px;
  border-radius: 4px;
  font-size: 14px;
  white-space: nowrap;            /* prevent line breaks */
  word-break: normal;             /* don't break words randomly */
  max-width: none;                /* allow width to grow as needed */
}

.custom-tooltip .tooltip-arrow {
  position: absolute;
  top: -6px;
  left: 20px;
  width: 12px;
  height: 12px;
  background-color: #ffffff;
  transform: rotate(45deg);
  box-shadow: -0.3rem 0 0.3rem rgba(0, 0, 0, 0.4);
  clip-path: polygon(0 0, 100% 0, 0 100%);
  z-index: 1;
}


.tooltip-content {
  font-size: 12px;
  font-family: "MarkBook", sans-serif;
  color: #333;
  line-height: 1.5;
  white-space: nowrap;           /* prevent line break */
  word-break: normal;
  display: inline-block;
}

.tooltip-content ul {
  list-style-type: disc;
  padding-left: 18px;
  margin: 0;
}

.copy-icon {
  font-size: 14px; 
  color: #666;
  cursor: pointer;
  transition: color 0.2s ease;
}

.copy-icon:hover {
  color: #000;
}

.ag-sort-indicator-icon[data-ref="eSortOrder"] {
  display: none !important;
}

/* .ag-body-horizontal-scroll,
.ag-body-horizontal-scroll-viewport,
.ag-body-horizontal-scroll-container {
  height: 16px !important;
  max-height: 16px !important;
  min-height: 16px !important;
  background-color: #f0f0f0;
}

.ag-body-horizontal-scroll-viewport::-webkit-scrollbar {
  height: 16px;
}

.ag-body-horizontal-scroll-viewport::-webkit-scrollbar-thumb {
  background: #999;
  border-radius: 8px;
}

.ag-body-horizontal-scroll-viewport::-webkit-scrollbar-track {
  background: #f0f0f0;
}

.ag-body-horizontal-scroll-viewport {
  scrollbar-width: auto;
  scrollbar-color: #999 #f0f0f0;
}

.ag-body-horizontal-scroll.ag-invisible,
.ag-body-horizontal-scroll.ag-invisible .ag-body-horizontal-scroll-viewport,
.ag-body-horizontal-scroll.ag-invisible .ag-body-horizontal-scroll-container {
  height: 0px !important;
  max-height: 0px !important;
  min-height: 0px !important;
  overflow-x: hidden !important;
} */
.ag-header-blocked{
  pointer-events: none !important;
  /* opacity: 0.6; */
}

.no-caret::after {
  display: none !important;
}

.breadcrumb-comment {
  display: inline-block;
  max-width: 200px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  vertical-align: middle;
  margin-left: 4px;
}

.wrap-header-text .ag-header-cell-label {
   white-space: normal !important;
    line-height: 1.4;
    word-wrap: break-word;
    padding-top: 8px;  
    display: flex;     
    align-items: center;
    height: 100%;       
}

/*

input[type="range"].form-range::-webkit-slider-runnable-track {
  background: white; 
  height: 7px; 
  border-radius: 2px; 
} 
input[type="range"].form-range::-moz-range-track { 
  background: white; 
  height: 7px; 
  border-radius: 2px; 
}

*/

/* For Row Height */
/* Chrome, Safari, Edge */
input[type="range"].form-range {
  appearance: none; /* remove default browser styling */
  background: transparent; /* let track styling show */
}

/* Full track */
input[type="range"].form-range::-webkit-slider-runnable-track {
  height: 7px;
  border-radius: 2px;
  background: linear-gradient(
    to right,
    #007bff var(--value, 50%),  /* filled (blue) */
    white var(--value, 50%)     /* unfilled (white) */
  );
}

/* Thumb */
input[type="range"].form-range::-webkit-slider-thumb {
  appearance: none;
  height: 14px;
  width: 14px;
  border-radius: 50%;
  background: #007bff;
  cursor: pointer;
  margin-top: -4px; /* center align thumb */
  border: 2px solid white;
}

/* Firefox */
input[type="range"].form-range::-moz-range-track {
  height: 7px;
  border-radius: 2px;
  background: white; /* fallback, full white */
}
input[type="range"].form-range::-moz-range-progress {
  height: 7px;
  border-radius: 2px;
  background: #007bff; /* filled left part */
}
input[type="range"].form-range::-moz-range-thumb {
  height: 14px;
  width: 14px;
  border-radius: 50%;
  background: #007bff;
  cursor: pointer;
  border: 2px solid white;
}
`, "",{"version":3,"sources":["webpack://./app_react/src/components/Common/DataTableEngine/AGGridDataTableEngine.css"],"names":[],"mappings":"AAAA;EACE,wCAAwC;EACxC,uBAAuB;EACvB,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;EACzB,mCAAmC;EACnC,gBAAgB;EAChB,qBAAqB;EACrB,eAAe;AACjB;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,oEAAoE;EACpE,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,mCAAmC;EACnC,2BAA2B;EAC3B,0BAA0B;EAC1B,yBAAyB;EACzB,uBAAuB;EACvB,wBAAwB;AAC1B;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,6BAA6B;AAC/B;AACA;EACE,uBAAuB;EACvB,WAAW;EACX,uBAAuB;AACzB;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,kBAAkB;EAClB,2BAA2B;EAC3B,kBAAkB;EAClB,uBAAuB;AACzB;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,eAAe;EACf,2BAA2B;EAC3B,kBAAkB;AACpB;;AAEA;IACI,eAAe;IACf,WAAW;AACf;;AAEA;EACE,eAAe;EACf,YAAY;EACZ,2BAA2B;EAC3B,gBAAgB;EAChB,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,sBAAsB;EACtB,WAAW;EACX,iBAAiB;EACjB,uDAAuD;AACzD;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,sBAAsB;EACtB,WAAW;AACb;;;AAGA;EACE,gBAAgB;EAChB,WAAW;EACX,kBAAkB;EAClB,kBAAkB;EAClB,0BAA0B;EAC1B,uBAAuB;AACzB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,WAAW;EACX,kBAAkB;EAClB,kBAAkB;EAClB,0BAA0B;AAC5B;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;IACI,aAAa;AACjB;;CAEC;EACC,gBAAgB;EAChB,wBAAwB;EACxB,qBAAqB;EACrB,sBAAsB;EACtB,kBAAkB;EAClB,uBAAuB;EACvB,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;AACvB;AACA;EACE,WAAW;EACX,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,UAAU;EACV,WAAW;EACX,mBAAmB;EACnB,yBAAyB;EACzB,wBAAwB;EACxB,aAAa;AACf;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,eAAe;EACf,eAAe;EACf,YAAY;CACb;;AAED;EACE,aAAa;EACb,2BAA2B;EAC3B,WAAW;CACZ;;AAED;EACE,aAAa;EACb,yBAAyB;EACzB,WAAW;AACb;;AAEA;EACE,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,sBAAsB;EACtB,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,UAAU;EACV,YAAY;EACZ,kBAAkB;EAClB,yBAAyB;EACzB,mDAAmD;EACnD,6CAA6C;AAC/C;AACA;EACE,UAAU;EACV,YAAY;EACZ,kBAAkB;EAClB,yBAAyB;EACzB,mDAAmD;EACnD,6CAA6C;AAC/C;;;AAGA;EACE;IACE,yBAAyB;EAC3B;EACA;IACE,yBAAyB;EAC3B;EACA;IACE,yBAAyB;EAC3B;AACF;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,gBAAgB;EAChB,yBAAyB;EACzB,wDAAwD;AAC1D;;AAEA;EACE;IACE,yBAAyB;EAC3B;EACA;IACE,yBAAyB;EAC3B;EACA;IACE,yBAAyB;EAC3B;AACF;;;AAGA;EACE,aAAa;EACb,QAAQ;EACR,uBAAuB;EACvB,mBAAmB;EACnB,YAAY;EACZ,YAAY;AACd;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,yBAAyB;EACzB,0DAA0D;EAC1D,6CAA6C;AAC/C;;AAEA;EACE;IACE,yBAAyB;EAC3B;EACA;IACE,yBAAyB;EAC3B;EACA;IACE,yBAAyB;EAC3B;AACF;;AAEA;EACE,UAAU;EACV,YAAY;EACZ,kBAAkB;EAClB;;;;;GAKC;EACD,0BAA0B;EAC1B,qDAAqD;EACrD,6CAA6C;AAC/C;;AAEA;EACE;IACE,2BAA2B;EAC7B;EACA;IACE,4BAA4B;EAC9B;AACF;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,WAAW;AACb;;AAEA;EACE,YAAY;EACZ,kBAAkB;EAClB;;;;;GAKC;EACD,0BAA0B;EAC1B,2DAA2D;EAC3D,6CAA6C;AAC/C;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE;IACE,2BAA2B;EAC7B;EACA;IACE,4BAA4B;EAC9B;AACF;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,gBAAgB;EAChB,yBAAyB;EACzB,0DAA0D;EAC1D,6CAA6C;AAC/C;;AAEA;EACE,eAAe;AACjB;AACA;EACE,uBAAuB;EACvB,kBAAkB;EAClB,kBAAkB;EAClB,yDAAyD;AAC3D;AACA;IACI,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA;EACE,mCAAmC;EACnC,kBAAkB;EAClB,yBAAyB;EACzB,yDAAyD;EACzD,qBAAqB,YAAY,6BAA6B;EAC9D,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,mBAAmB,aAAa,wBAAwB;EACxD,kBAAkB,cAAc,+BAA+B;EAC/D,eAAe,iBAAiB,kCAAkC;AACpE;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,UAAU;EACV,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,wBAAwB;EACxB,+CAA+C;EAC/C,uCAAuC;EACvC,UAAU;AACZ;;;AAGA;EACE,eAAe;EACf,mCAAmC;EACnC,WAAW;EACX,gBAAgB;EAChB,mBAAmB,YAAY,uBAAuB;EACtD,kBAAkB;EAClB,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;EACrB,kBAAkB;EAClB,SAAS;AACX;;AAEA;EACE,eAAe;EACf,WAAW;EACX,eAAe;EACf,2BAA2B;AAC7B;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;GAkCG;AACH;EACE,+BAA+B;EAC/B,kBAAkB;AACpB;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,qBAAqB;EACrB,gBAAgB;EAChB,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;EACvB,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA;GACG,8BAA8B;IAC7B,gBAAgB;IAChB,qBAAqB;IACrB,gBAAgB;IAChB,aAAa;IACb,mBAAmB;IACnB,YAAY;AAChB;;AAEA;;;;;;;;;;;;;CAaC;;AAED,mBAAmB;AACnB,yBAAyB;AACzB;EACE,gBAAgB,EAAE,mCAAmC;EACrD,uBAAuB,EAAE,2BAA2B;AACtD;;AAEA,eAAe;AACf;EACE,WAAW;EACX,kBAAkB;EAClB;;;;GAIC;AACH;;AAEA,UAAU;AACV;EACE,gBAAgB;EAChB,YAAY;EACZ,WAAW;EACX,kBAAkB;EAClB,mBAAmB;EACnB,eAAe;EACf,gBAAgB,EAAE,uBAAuB;EACzC,uBAAuB;AACzB;;AAEA,YAAY;AACZ;EACE,WAAW;EACX,kBAAkB;EAClB,iBAAiB,EAAE,yBAAyB;AAC9C;AACA;EACE,WAAW;EACX,kBAAkB;EAClB,mBAAmB,EAAE,qBAAqB;AAC5C;AACA;EACE,YAAY;EACZ,WAAW;EACX,kBAAkB;EAClB,mBAAmB;EACnB,eAAe;EACf,uBAAuB;AACzB","sourcesContent":[".schema-engine-status-list .list-group-item{\n  background-color: transparent !important;\n  border: none !important; \n  padding: 0.25rem 0; \n}\n\n.ag-header {\n  background-color: #f4f4f4; \n  font-family: \"MarkBook\", sans-serif;\n  font-weight: 500; \n  letter-spacing: 0.5px; \n  font-size: 12px;\n}\n\n.ag-header-cell, .ag-header {\n  overflow: visible !important;\n}\n\n.ag-header-cell[aria-sort=\"none\"] .ag-header-cell-text::after {\n  font-family: \"Font Awesome 7 Pro\", \"Font Awesome 5 Free\", sans-serif; \n  content: '\\f0dc'; \n  font-size: 12px;\n  color: #000000d8;\n  margin-left: 10px;\n  margin-top: 0px; \n}\n \n.ag-cell {\n  font-family: \"MarkBook\", sans-serif;\n  font-weight: 400 !important;\n  font-size: 12px !important; \n  color: #212121 !important; \n  border: none !important;\n  text-overflow: ellipsis ;\n}\n\n.ag-cell.ag-cell-actions-dropdown {\n  overflow: visible;\n}\n\n.ag-column-last{\n  border-right: 0px  !important;\n}\n.ag-floating-filter {  \n  text-overflow: ellipsis;  \n  width: 100%;  \n  border: none !important;\n} \n \n.ag-input-field-input.ag-text-field-input::placeholder {\n  color: #00000080 !important;\n}\n\n.ag-input-field-input::placeholder {\n  color: #00000080 !important;\n}\n\n.ag-input-field-input{\n  padding-inline: 6%;\n  border: 1px solid #0000006c;\n  border-radius: 4px; \n  text-overflow: ellipsis;\n}\n\n.ag-input-field-input:focus {\n  border: 1px solid #60a5fa !important;  \n}\n\n.ag-floating-filter select{\n  padding-inline: 6%;\n  width: 100%;\n  margin-top: 0px;\n  border: 1px solid #0000006c;\n  border-radius: 4px; \n}\n\n.ag-floating-filter-body  {\n    margin-top: 0px;\n    width: 100%;\n} \n  \n.boolean-toggle-floating-filter {\n  padding: 0 10px;\n  height: 24px;\n  border: 1px solid #0000006c;\n  border-radius: 0;\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 14px;\n  background-color: #fff;\n  color: #000;\n  user-select: none;\n  transition: background-color 0.2s ease, color 0.2s ease;\n}\n\n.boolean-toggle-floating-filter.up {\n  border-radius: 4px 0 0 4px;\n}\n\n.boolean-toggle-floating-filter.down {\n  border-radius: 0 4px 4px 0;\n}\n\n.boolean-toggle-floating-filter.selected {\n  background-color: #000;\n  color: #fff;\n}\n\n \n.select-empty {\n  color: #00000080;\n  width: 100%;\n  padding-inline: 6%; \n  border-radius: 4px;\n  background-color: #ffffff ;\n  text-overflow: ellipsis;\n}\n\n.select-normal { \n  font-style: normal;\n  color: #000;\n  width: 100%;\n  padding-inline: 6%; \n  border-radius: 4px;\n  background-color: #ffffff ;\n}\n\n.option-empty {\n  color: #00000080;\n  font-style: italic;\n}\n\n.option-normal {\n  color: #000;\n  font-style: normal;\n}\n\n.ag-floating-filter-input {\n  font-weight: normal;\n}\n\n.ag-floating-filter-button-button{\n    display: none;\n}\n \n input.grey-checkbox[type=\"checkbox\"] {\n  appearance: none;\n  -webkit-appearance: none;\n  -moz-appearance: none;\n  border: 2px solid #aaa;\n  border-radius: 4px;\n  background-color: white;\n  cursor: pointer;\n  position: relative;\n}\n\ninput.grey-checkbox[type=\"checkbox\"]:checked {\n  background-color: #8e8b8b; \n  border-color: #000000;\n}\ninput.grey-checkbox[type=\"checkbox\"]::after {\n  content: '';\n  position: absolute;\n  top: 1px;\n  left: 4px;\n  width: 4px;\n  height: 9px;\n  border: solid white;\n  border-width: 0 2px 2px 0;\n  transform: rotate(45deg);\n  display: none;\n}\n\ninput.grey-checkbox[type=\"checkbox\"]:checked::after {\n  display: block;\n}\n\n.ag-paging-panel {\n  align-items: center;\n  padding: 0 12px;\n  font-size: 13px;\n  height: 35px;\n }\n\n.ag-paging-button:first-child {\n  display: flex;\n  justify-content: flex-start;\n  width: 50px;\n }\n\n.ag-paging-button:last-child {\n  display: flex;\n  justify-content: flex-end;\n  width: 50px;\n}\n\n.ag-paging-page-summary-panel {\n  width: 200px;\n  text-align: center;\n  white-space: nowrap;      \n  overflow: hidden;         \n  text-overflow: ellipsis;  \n}\n\n.ag-paging-row-summary-panel {\n  width: 160px;\n  text-align: center;\n}\n\n.skeleton-wrapper {\n  width: 100%;\n  height: 100%;\n  box-sizing: border-box;\n  display: flex;\n  align-items: center;\n}\n\n.skeleton-box {\n  width: 85%;\n  height: 20px;\n  border-radius: 6px;\n  background-color: #e0e0e0;\n  animation: skeleton-pulse 1.2s ease-in-out infinite;\n  box-shadow: inset 0 0 4px rgba(0, 0, 0, 0.05);\n}\n.skeleton-box-short {\n  width: 65%;\n  height: 20px;\n  border-radius: 6px;\n  background-color: #e0e0e0;\n  animation: skeleton-pulse 1.2s ease-in-out infinite;\n  box-shadow: inset 0 0 4px rgba(0, 0, 0, 0.05);\n}\n\n\n@keyframes skeleton-pulse {\n  0% {\n    background-color: #e0e0e0;\n  }\n  50% {\n    background-color: #f0f0f0;\n  }\n  100% {\n    background-color: #e0e0e0;\n  }\n}\n\n.skeleton-icon {\n  width: 24px;\n  height: 24px;\n  border-radius: 50%;\n  margin-left: 40%;\n  background-color: #e0e0e0;\n  animation: skeleton-icon-pulse 1.2s ease-in-out infinite;\n}\n\n@keyframes skeleton-icon-pulse {\n  0% {\n    background-color: #e0e0e0;\n  }\n  50% {\n    background-color: #f0f0f0;\n  }\n  100% {\n    background-color: #e0e0e0;\n  }\n}\n\n\n.skeleton-button-row {\n  display: flex;\n  gap: 8px;\n  justify-content: center;\n  align-items: center;\n  height: 100%;\n  padding: 8px;\n}\n\n.skeleton-button {\n  width: 25px;\n  height: 25px;\n  border-radius: 6px;\n  background-color: #e0e0e0;\n  animation: skeleton-button-pulse 1.4s ease-in-out infinite;\n  box-shadow: inset 0 0 2px rgba(0, 0, 0, 0.05);\n}\n\n@keyframes skeleton-button-pulse {\n  0% {\n    background-color: #e0e0e0;\n  }\n  50% {\n    background-color: #f0f0f0;\n  }\n  100% {\n    background-color: #e0e0e0;\n  }\n}\n\n.skeleton-date {\n  width: 70%;\n  height: 16px;\n  border-radius: 4px;\n  background: linear-gradient(\n    90deg,\n    #e0e0e0 0%,\n    #f0f0f0 50%,\n    #e0e0e0 100%\n  );\n  background-size: 200% 100%;\n  animation: skeleton-loading 1.5s ease-in-out infinite;\n  box-shadow: inset 0 0 4px rgba(0, 0, 0, 0.05);\n}\n\n@keyframes skeleton-loading {\n  0% {\n    background-position: 200% 0;\n  }\n  100% {\n    background-position: -200% 0;\n  }\n}\n\n.skeleton-state {\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n  width: 100%;\n}\n\n.skeleton-line {\n  height: 10px;\n  border-radius: 4px;\n  background: linear-gradient(\n    90deg,\n    #d3d3d3 0%,\n    #eaeaea 50%,\n    #d3d3d3 100%\n  );\n  background-size: 200% 100%;\n  animation: skeleton-state-loading 1.4s ease-in-out infinite;\n  box-shadow: inset 0 0 4px rgba(0, 0, 0, 0.05);\n}\n\n.skeleton-line.short {\n  width: 20%;\n}\n\n.skeleton-line.long {\n  width: 60%;\n}\n\n@keyframes skeleton-state-loading {\n  0% {\n    background-position: 200% 0;\n  }\n  100% {\n    background-position: -200% 0;\n  }\n}\n\n.skeleton-image {\n  width: 28px;\n  height: 28px;\n  border-radius: 6px;\n  margin-left: 25%;\n  background-color: #e0e0e0;\n  animation: skeleton-button-pulse 1.4s ease-in-out infinite;\n  box-shadow: inset 0 0 2px rgba(0, 0, 0, 0.05);\n}\n\n.operationalStatus-tooltip-body > * + * {\n  margin-top: 5px; \n}\n.operationalStatus-tooltip-body{\n  background-color: white;\n  border-radius: 5px;\n  margin-bottom: 0px;\n  box-shadow: 0 .2rem 0.3rem rgba(0, 0, 0, 0.38) !important;\n} \n.operationalStatus-tooltip-status{\n    font-size: small;\n    font-style: italic;\n}\n\n.custom-tooltip {\n  font-family: \"MarkBook\", sans-serif;\n  position: relative;\n  background-color: #ffffff;\n  box-shadow: 0 .2rem 0.3rem rgba(0, 0, 0, 0.38) !important;\n  display: inline-block;           /* allows width to auto-fit */\n  padding: 8px 12px;\n  border-radius: 4px;\n  font-size: 14px;\n  white-space: nowrap;            /* prevent line breaks */\n  word-break: normal;             /* don't break words randomly */\n  max-width: none;                /* allow width to grow as needed */\n}\n\n.custom-tooltip .tooltip-arrow {\n  position: absolute;\n  top: -6px;\n  left: 20px;\n  width: 12px;\n  height: 12px;\n  background-color: #ffffff;\n  transform: rotate(45deg);\n  box-shadow: -0.3rem 0 0.3rem rgba(0, 0, 0, 0.4);\n  clip-path: polygon(0 0, 100% 0, 0 100%);\n  z-index: 1;\n}\n\n\n.tooltip-content {\n  font-size: 12px;\n  font-family: \"MarkBook\", sans-serif;\n  color: #333;\n  line-height: 1.5;\n  white-space: nowrap;           /* prevent line break */\n  word-break: normal;\n  display: inline-block;\n}\n\n.tooltip-content ul {\n  list-style-type: disc;\n  padding-left: 18px;\n  margin: 0;\n}\n\n.copy-icon {\n  font-size: 14px; \n  color: #666;\n  cursor: pointer;\n  transition: color 0.2s ease;\n}\n\n.copy-icon:hover {\n  color: #000;\n}\n\n.ag-sort-indicator-icon[data-ref=\"eSortOrder\"] {\n  display: none !important;\n}\n\n/* .ag-body-horizontal-scroll,\n.ag-body-horizontal-scroll-viewport,\n.ag-body-horizontal-scroll-container {\n  height: 16px !important;\n  max-height: 16px !important;\n  min-height: 16px !important;\n  background-color: #f0f0f0;\n}\n\n.ag-body-horizontal-scroll-viewport::-webkit-scrollbar {\n  height: 16px;\n}\n\n.ag-body-horizontal-scroll-viewport::-webkit-scrollbar-thumb {\n  background: #999;\n  border-radius: 8px;\n}\n\n.ag-body-horizontal-scroll-viewport::-webkit-scrollbar-track {\n  background: #f0f0f0;\n}\n\n.ag-body-horizontal-scroll-viewport {\n  scrollbar-width: auto;\n  scrollbar-color: #999 #f0f0f0;\n}\n\n.ag-body-horizontal-scroll.ag-invisible,\n.ag-body-horizontal-scroll.ag-invisible .ag-body-horizontal-scroll-viewport,\n.ag-body-horizontal-scroll.ag-invisible .ag-body-horizontal-scroll-container {\n  height: 0px !important;\n  max-height: 0px !important;\n  min-height: 0px !important;\n  overflow-x: hidden !important;\n} */\n.ag-header-blocked{\n  pointer-events: none !important;\n  /* opacity: 0.6; */\n}\n\n.no-caret::after {\n  display: none !important;\n}\n\n.breadcrumb-comment {\n  display: inline-block;\n  max-width: 200px;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  vertical-align: middle;\n  margin-left: 4px;\n}\n\n.wrap-header-text .ag-header-cell-label {\n   white-space: normal !important;\n    line-height: 1.4;\n    word-wrap: break-word;\n    padding-top: 8px;  \n    display: flex;     \n    align-items: center;\n    height: 100%;       \n}\n\n/*\n\ninput[type=\"range\"].form-range::-webkit-slider-runnable-track {\n  background: white; \n  height: 7px; \n  border-radius: 2px; \n} \ninput[type=\"range\"].form-range::-moz-range-track { \n  background: white; \n  height: 7px; \n  border-radius: 2px; \n}\n\n*/\n\n/* For Row Height */\n/* Chrome, Safari, Edge */\ninput[type=\"range\"].form-range {\n  appearance: none; /* remove default browser styling */\n  background: transparent; /* let track styling show */\n}\n\n/* Full track */\ninput[type=\"range\"].form-range::-webkit-slider-runnable-track {\n  height: 7px;\n  border-radius: 2px;\n  background: linear-gradient(\n    to right,\n    #007bff var(--value, 50%),  /* filled (blue) */\n    white var(--value, 50%)     /* unfilled (white) */\n  );\n}\n\n/* Thumb */\ninput[type=\"range\"].form-range::-webkit-slider-thumb {\n  appearance: none;\n  height: 14px;\n  width: 14px;\n  border-radius: 50%;\n  background: #007bff;\n  cursor: pointer;\n  margin-top: -4px; /* center align thumb */\n  border: 2px solid white;\n}\n\n/* Firefox */\ninput[type=\"range\"].form-range::-moz-range-track {\n  height: 7px;\n  border-radius: 2px;\n  background: white; /* fallback, full white */\n}\ninput[type=\"range\"].form-range::-moz-range-progress {\n  height: 7px;\n  border-radius: 2px;\n  background: #007bff; /* filled left part */\n}\ninput[type=\"range\"].form-range::-moz-range-thumb {\n  height: 14px;\n  width: 14px;\n  border-radius: 50%;\n  background: #007bff;\n  cursor: pointer;\n  border: 2px solid white;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
